var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PostRepository } from '@amityco/js-sdk';
import useMemoAsync from '../../core/hooks/useMemoAsync';
import usePostChildren from '../../social/hooks/usePostChildren';
import useLiveObject from '../../core/hooks/useLiveObject';
import useUser from '../../core/hooks/useUser';
import { useActionEvents } from '../../core/providers/ActionProvider';
const usePost = (postId) => {
    const post = useLiveObject(() => PostRepository.postForId(postId), [postId]);
    const isPostReady = !!post.postId;
    const { postedUserId, children } = post;
    const actionEvents = useActionEvents();
    const { user, file } = useUser(postedUserId);
    const handleUpdatePost = (data, props) => PostRepository.updatePost(Object.assign({ postId, data }, props));
    const handleReportPost = () => PostRepository.flag(postId);
    const handleUnreportPost = () => PostRepository.unflag(postId);
    const handleDeletePost = () => PostRepository.deletePost(postId);
    const handleApprovePost = () => PostRepository.approvePost(postId);
    const handleDeclinePost = () => PostRepository.declinePost(postId);
    const handleCommentingToggle = () => {
        var _a;
        handleUpdatePost(post.data, {
            metadata: Object.assign(Object.assign({}, post.metadata), { areCommentsHidden: false, isCommentingDisabled: !post.metadata.isCommentingDisabled }),
        });
        (_a = actionEvents.onCommentsToggled) === null || _a === void 0 ? void 0 : _a.call(actionEvents, {
            target: 'post',
            value: post.metadata.isCommentingDisabled ? 'on' : 'off',
        });
    };
    const childrenPosts = usePostChildren(children);
    const isFlaggedByMe = useMemoAsync(() => __awaiter(void 0, void 0, void 0, function* () { return (isPostReady ? PostRepository.isFlaggedByMe(post.postId) : false); }), [isPostReady, post]);
    return {
        isPostReady,
        post,
        user,
        file,
        handleUpdatePost,
        handleReportPost,
        handleUnreportPost,
        handleDeletePost,
        handleApprovePost,
        handleDeclinePost,
        childrenPosts,
        isFlaggedByMe,
        handleCommentingToggle,
    };
};
export default usePost;
//# sourceMappingURL=usePost.js.map